const breakpoint = 1024;
let searchWrapper = document.querySelector('.search-wrapper.desktop');
let searchPage = document.querySelector('body.search:not(.archive)');

if(searchWrapper && window.innerWidth >= breakpoint) {
    let searchIcon = searchWrapper.querySelector('button.search-btn');
    if (searchIcon) {
        let search = searchWrapper.querySelector('#search');
        let searchInput = searchWrapper.querySelector('#search #search-input');
        searchIcon.addEventListener('click', function (e) {
            e.preventDefault();
            if(search.classList.contains('expand')) {
                search.classList.remove('expand');
            }
            else {
                search.classList.add('expand');
                searchInput.focus();
            }
        });

        document.addEventListener('click', function (e) {
            if (search.classList.contains('expand') && !searchWrapper.contains(e.target)) {
                search.classList.remove('expand');
            }
        });
    }
}


if (searchPage) {
    let pageSearchInput = searchPage.querySelector('#search-page #search-page-input');
    let inputValue = searchPage.querySelector('#content-section #search-page #search-page-input').value;
    pageSearchInput.focus();
    pageSearchInput.value = '';
    pageSearchInput.value = inputValue;
}
